<script>
  export let rowHeight;
  export let cellWidth;

  export let selectedUnitPeriod;
  
  export let timeGroupsDay;
  export let timeGroupsWeek;
  export let timeGroupsMonth;

  export let visibleDays;
  export let visibleWeeks;
  export let visibleMonths;
  export let visibleRows;

  export let viewMode;

  export let handleScrollPeriodHeader;
  export let handleScrollPeriodBody;
  function parseGroupToDate(group) {
    const [yearStr, monthStr] = group.split("年");
    const year = parseInt(yearStr);
    const month = parseInt(monthStr);
    if (!isNaN(year) && !isNaN(month)) {
        // Month in Date constructor is 0-based, so subtract 1
        return new Date(year, month - 1);
    }
    return null; // Return null if parsing fails
  }

  function getColorClass(percentage) {
    const value = parseInt(percentage);
    if (value == -100) {
      return "";
    } else if (value == 0) {
      return "zero-color";
    } else if (value <= 20) {
      return "twenty-color";
    } else if (value <= 40) {
      return "forty-color";
    } else if (value <= 60) {
      return "sixty-color";
    } else if (value <= 90) {
      return "eighty-color";
    } else {
      return "hundred-color";
    }
  }

  function getBarColor(percentage) {
    // percentage in [-100,0-100]

    const value = parseInt(percentage);

    if (value == -100) {
      return "";
    } else if (value <= 20) {
      return "#EBF6FF";
    } else if (value <= 40) {
      return "#CCE8FF";
    } else if (value <= 60) {
      return "#A6D6FF";
    } else if (value <= 80) {
      return "#80C5FF";
    } else {
      return "#4DADFF";
    }
  }

  function overHundred(percentage) {
    const value = parseInt(percentage);
    if (value > 100) {
      return "bolder";
    }
  }

  function groupByYear(timeGroupsMonth) {
  const grouped = {};
  for (const [key, months] of Object.entries(timeGroupsMonth)) {
    const year = key.split("年")[0]; // Extract the year from the key
    if (!grouped[year]) {
      grouped[year] = [];
    }
    grouped[year].push(...months); // Add the months to the corresponding year
  }
  return grouped;
}
</script>

<table>
  <thead on:wheel={handleScrollPeriodHeader}>
    <tr>
      {#if selectedUnitPeriod === "day"}
        {#each Object.keys(timeGroupsDay) as group (group)}
          {#if timeGroupsDay[group].some((day) => visibleDays.includes(day))}
            <th
              class="month-header"
              colspan={timeGroupsDay[group].filter((day) =>
                visibleDays.includes(day)
              ).length}
              style="max-width: {cellWidth}px;"
            >
              <div>
                <span style="margin-left: 10px;">{group}</span>
              </div>
            </th>
          {/if}
        {/each}

      {:else if selectedUnitPeriod === "week"}
        {#each Object.keys(timeGroupsWeek) as group (group)}
          {#if timeGroupsWeek[group].some((week) => visibleWeeks.includes(week))}
            <th
              class="month-header"
              colspan={timeGroupsWeek[group].filter((week) =>
                visibleWeeks.includes(week)
              ).length}
              style="max-width: {cellWidth}px;"
            >
              <span style="margin-left: 10px;">{group}</span>
            </th>
          {/if}
        {/each}

      {:else if selectedUnitPeriod === "month"}
        {#each Object.entries(groupByYear(timeGroupsMonth)) as [year, months]}
          {#if months.some((month) => visibleMonths.includes(month))}
            <th
              class="month-header"
              colspan={months.filter((month) => visibleMonths.includes(month)).length}
              style="max-width: {cellWidth}px;"
            >
              <span style="margin-left: 10px;">
                {new Date(parseInt(year), 0).toLocaleDateString("ja-JP", { year: "numeric" })}
              </span>
            </th>
          {/if}
        {/each}

      {/if}
    </tr>
    <!-- Original Weeks header part -->
    <tr>
      {#if selectedUnitPeriod === "day"}
        {#each Object.entries(timeGroupsDay) as [month, days] (month)}
          {#each days as day, index (day)}
            {#if visibleDays.includes(day)}
              <th
                class="week-header {index === 0
                  ? 'first-week'
                  : ''} {index === days.length - 1 ? 'last-week' : ''}
                  {day === visibleDays[0] ? 'first-week' : ''}
                  {day.slice(-1) === '土' ? 'saturday' : ''}
                  {day.slice(-1) === '日' ? 'sunday' : ''}
                  "
                >
                  <div style="width: {cellWidth}px;">{day.replace(/^\d{1,2}\//, "")}</div>
                
              </th>
            {/if}
          {/each}
        {/each}

      {:else if selectedUnitPeriod === "week"}
        {#each Object.entries(timeGroupsWeek) as [month, weeks] (month)}
          {#each weeks as week, index (week)}
            {#if visibleWeeks.includes(week)}
              <th
              class="week-header {index === 0 ? 'first-week' : ''} 
                    {index === weeks.length - 1 ? 'last-week' : ''} 
                    {week === visibleWeeks[0] ? 'first-week' : ''}
                    "
              style="width: {cellWidth}px;"
              >
                <div style="width: {cellWidth}px;">{week.replace(/\d{1,2}\/(\d{1,2})\((.)\)/g, '$1($2)').replace("-", "\n-")}</div>
              </th>
            {/if}
          {/each}
        {/each}

      {:else if selectedUnitPeriod === "month"}
        {#each Object.entries(groupByYear(timeGroupsMonth)) as [year, months] (year)}
          {#each months as month, index (month)}
            {#if visibleMonths.includes(month)}
              <th
                class="week-header 
                  {index === 0 ? 'first-week': ''} 
                  {index === months.length - 1 ? 'last-week' : ''}
                  {month === visibleMonths[0] ? 'first-week' : ''}"
                >
                <div style="width: {cellWidth}px;">
                  {
                    new Date(
                      parseInt(month.split("年")[0]), // Extract year from "2023年11月"
                      parseInt(month.split("年")[1].replace("月", "")) - 1 // Extract and adjust month
                    ).toLocaleDateString("ja-JP", { month: "long" })
                  }
                </div>
              </th>
            {/if}
          {/each}
        {/each}
      {/if}
    </tr>
  </thead>
  <tbody on:wheel={handleScrollPeriodBody}>
    {#each visibleRows as row, index1} 
      <tr>
        {#if selectedUnitPeriod === "day" }
          {#each Object.entries(timeGroupsDay) as [month, intervals] (month)}
            {#each intervals as day, index2 (day)}
              {#if visibleDays.includes(day)}
                {@const percentage = row.percentages[month][intervals.indexOf(day)]}
                <td
                  class={`${
                    viewMode === "colorScale"
                      ? "percentage-cell-colorScale"
                      : "percentage-cell-dataBar"
                  } percentage-cell ${
                    index1 === visibleRows.length - 1 ? "last-row" : ""
                  } ${index2 === 0 ? "first-entry" : ""} ${
                    index2 === intervals.length - 1 ? "last-entry" : ""
                  } ${day === visibleDays[0] ? "first-entry" : ""}`}
                >
                  <div style="width: {cellWidth}px; height: {rowHeight}px;">
                    {#if viewMode === "colorScale" || viewMode === ""}
                      <div class="percentage-inner {getColorClass(percentage)}">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                      </div>
                    {:else if viewMode === "dataBar"}
                      <div class="data-bar-container">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                        {#if percentage > 100}
                          <div class="percentage-inner {getColorClass(percentage)}">
                          </div>
                        {:else}
                          {#if percentage != -100}
                            <div class="bar">
                              <div
                                class="percentage-inner"
                                style="height: {100 -
                                  parseInt(percentage)}%; background-color: #FFFFFF;"
                              />
                              <div
                                class="percentage-inner"
                                style="height: {percentage}%; background-color: #8DC2FA;"
                              />
                            </div>
                          {:else}
                            <div class="bar" />
                          {/if}
                        {/if}
                      </div>
                    {/if}
                  </div>
                </td>
              {/if}
            {/each}
          {/each}

        {:else if selectedUnitPeriod === "week"}
          {#each Object.entries(timeGroupsWeek) as [month, intervals] (month)}
            {#each intervals as week, index2 (week)}
              {#if visibleWeeks.includes(week)}
                {@const percentage = row.percentages[month][intervals.indexOf(week)]}
                <td
                  class={`${
                    viewMode === "colorScale"
                      ? "percentage-cell-colorScale"
                      : "percentage-cell-dataBar"
                  } percentage-cell ${
                    index1 === visibleRows.length - 1 ? "last-row" : ""
                  } ${index2 === 0 ? "first-entry" : ""} ${
                    index2 === intervals.length - 1 ? "last-entry" : ""
                  } ${week === visibleWeeks[0] ? "first-entry" : ""}`}
                >
                  <div style="width: {cellWidth}px; height: {rowHeight}px;">
                    {#if viewMode === "colorScale" || viewMode === ""}
                      <div class="percentage-inner {getColorClass(percentage)}">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                      </div>
                    {:else if viewMode === "dataBar"}
                      <div class="data-bar-container">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                        {#if percentage > 100}
                          <div class="percentage-inner {getColorClass(percentage)}">
                          </div>
                        {:else}
                          {#if percentage != -100}
                            <div class="bar">
                              <div
                                class="percentage-inner"
                                style="height: {100 -
                                  parseInt(percentage)}%; background-color: #FFFFFF;"
                              />
                              <div
                                class="percentage-inner"
                                style="height: {percentage}%; background-color: #8DC2FA;"
                              />
                            </div>
                          {:else}
                            <div class="bar" />
                          {/if}
                        {/if}
                      </div>
                    {/if}
                  </div>
                </td>
              {/if}
            {/each}
          {/each}

        {:else if selectedUnitPeriod === "month"}
          {#each Object.entries(groupByYear(timeGroupsMonth)) as [year, intervals] (year)}
            {#each intervals as month1, index2 (month1)}
              {#if visibleMonths.includes(month1)}
                {@const percentage = row.percentages[month1][0]}
                <td
                  class={`${
                    viewMode === "colorScale"
                      ? "percentage-cell-colorScale"
                      : "percentage-cell-dataBar"
                  } percentage-cell ${
                    index1 === visibleRows.length - 1 ? "last-row" : ""
                  } ${index2 === 0 ? "first-entry" : ""} ${
                    index2 === intervals.length - 1 ? "last-entry" : ""
                  } ${month1 === visibleMonths[0] ? "first-entry" : ""}`}
                >
                  <div style="width: {cellWidth}px; height: {rowHeight}px;">
                    {#if viewMode === "colorScale" || viewMode === ""}
                      <div class="percentage-inner {getColorClass(percentage)}">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                      </div>
                    {:else if viewMode === "dataBar"}
                      <div class="data-bar-container">
                        <span class="{overHundred(percentage)}">{percentage == -100 ? "" : `${Math.floor(percentage)}%`}</span>
                        {#if percentage > 100}
                          <div class="percentage-inner {getColorClass(percentage)}">
                          </div>
                        {:else}
                          {#if percentage != -100}
                            <div class="bar">
                              <div
                                class="percentage-inner"
                                style="height: {100 -
                                  parseInt(percentage)}%; background-color: #FFFFFF;"
                              />
                              <div
                                class="percentage-inner"
                                style="height: {percentage}%; background-color: #8DC2FA;"
                              />
                            </div>
                          {:else}
                            <div class="bar" />
                          {/if}
                        {/if}
                      </div>
                    {/if}
                  </div>
                </td>
              {/if}
            {/each}
          {/each}

        {/if}

      </tr>
    {/each}
  </tbody>
</table>
  
<style>

  table {
    height: 100%;
    border-collapse: collapse;
    table-layout: fixed;

  }

  th,
  td {
    text-align: center;
    box-sizing: border-box;
  }

  th {
    padding: 0 !important;
    border: 2px solid #888888;
  }

  td {
    background-color: #ffffff;
    padding: 0;
  }

  .month-header {
    font-size: 12px;
    font-weight: 500;
    background-color: white;
    height: 25px;
    border-bottom: 2px solid #d5d5d5;
    border-right: 2px solid #888888;
    border-left: 2px solid #888888;
    overflow: hidden;
    white-space: nowrap;
  }

  .week-header {
    white-space: pre-line;
    background-color: white;
    font-size: 12px;
    font-weight: 500;
    border-left: 2px solid #c9c6c6;
    border-right: 2px solid #c9c6c6;
    border-top: 2px solid #c9c6c6;
    border-bottom: 2px solid #888888;
    height: 55px;
  }

  .first-week {
    border-left: 2px solid #888888;;
  }

  .last-week {
    border-right: 2px solid #888888;

  }

  .saturday {
    background-color: lightblue;
  }

  .sunday {
    background-color: #ffcccb;
  }



/*   .last-week::before {
    content: "";
    width: 2px;
    height: 100%;
    background-color: #888888;
    position: absolute;
    right: -2px;
    top: -3px;
  } */

  th.month-header {
    text-align: left;
    /* height:20px; */
  }

  /* th.week-header {
    
  } */

  .normal-data {
    background-color: #e9e9ef;
    font-size: 16px;
    font-weight: 500;
  }

  .percentage-cell-dataBar {
    border: 2px solid #c9c6c6;
  }

  .percentage-cell-colorScale {
    border: 2px dotted #c9c6c6;
  }

  .first-entry {
    border-left: 2px solid #888888;
  }

  .last-entry {
    border-right: 2px solid #888888;
  }
/*   .last-entry::before {
    content: "";
    width: 2px;
    height: 100%;
    background-color: #888888;
    position: absolute;
    right: -2px;
    bottom: -2px;
  } */

  .last-row {
    border-bottom: 2px solid #888888;
  }

  /* Percentage cell part */
  .data-bar-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .data-bar-container span {
    position: absolute;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bar {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
    flex-direction: column;
    justify-content: flex-end;
  }

  .data-bar-container span {
    width: 100%;
    text-align: center;
  }
  .bolder {
    font-weight: 900;
  }
  .percentage-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-weight: 500;
    /* font-size: 26px; */
    overflow: hidden;
  }

  .zero-color {
    background-color: #ffffff;
  }
  .twenty-color {
    background-color: #ebf6ff;
  }

  .forty-color {
    background-color: #cce8ff;
  }

  .sixty-color {
    background-color: #a6d6ff;
  }

  .eighty-color {
    background-color: #80c5ff;
  }

  .hundred-color {
    background-color: #4dadff;
  }
</style>